module.exports = __webpack_public_path__ + "img/海洋研究所-无颜色.5a1a8964.png";